import React from 'react';
import toNumber from 'lodash/toNumber';

class OpacitySlider extends React.Component {
  constructor(props){
    super(props);
    this.handleChange = this.handleChange.bind(this);
    this.setCSSText = this.setCSSText.bind(this);
    this.setOpacity = this.setOpacity.bind(this);
    const initial =this.setCSSText(props.layer.getOpacity())
    this.state = initial
    
  }
  setOpacity(){
    const { layer } = this.props;
    layer.setOpacity(toNumber(this.state.opacity));
  }
  setCSSText(val) {
    const prefs = ['webkit-slider-runnable', 'moz-range', 'ms-track'];
    const len = prefs.length;
    const min = 0;
    const max = 1;
    const perc = (max) ? ~~(100 * (val - min) / (max - min)) : val;
    const valString = perc + '% 100%';
    let str = '';
    for (var i = 0; i < len; i++) {
      str +=  ' input[type=range]::-' + prefs[i] + '-track{background-size:' + valString + '}';
    }
    return {
      opacity: val,
      style: str
    };
  }
  handleChange(e){
    const val = e.currentTarget.value;
    const currentState = this.setCSSText(val);
    this.setState(currentState, this.setOpacity)
  }
  OpacityChangeIE(e) {
    if(window.isIE) {
      const val = e.currentTarget.value;
      const currentState = this.setCSSText(val);
      this.setState(currentState, this.setOpacity)
    }
  }

  render(){
    const { opacity, style} = this.state;
    const formattedOpacity = '' + Math.round(opacity * 100) + '%';
    return (
      <div style={{display: 'block'}}>
        <hr/>
        <div className="form-group" style={{marginTop:'12px'}}>
          <label className="control-label">Opacity: { formattedOpacity }</label>
          <form></form>
          <input className="cm-input opacity-span" onChange ={this.handleChange}
              value={opacity} onMouseUp={this.onOpacityChangeIE} type='range' min="0" max="1" step = '0.01'></input>
          <style >{style}</style>
        </div>
      </div>
    )
  }
}

export default OpacitySlider;